module.exports = __webpack_public_path__ + "static/media/asseticon.221af8ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asseticon.svg
// module id = 1725
// module chunks = 0